import { ArrowBack, FolderZipOutlined } from "@mui/icons-material";
import { Box, Divider, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useQueryParams } from "../../../../hooks/useQueryParams";
import { formatMonthToNumber } from "../_utils/format-month";
import GJChip from "../../../../components/GJChip";
import CardFolder from "../../../../components/CardFolder ";
import FolderLoader from "../../FolderLoader";
import NoRecordsFound from "../../../../components/NoRecordsFound";
import DocumentAccrualReversalAllBatch from "../DocumentAccrualReversalAllBatch";

const Year = () => {
  const { year } = useParams();
  const { data, isFetching, isSuccess, isError } = useOutletContext();
  const navigate = useNavigate();
  const { searchParams, removeQueryParams } = useQueryParams();

  const navigateToMonthFolder = (month) => {
    navigate({
      pathname: `/general-journal/accrual-and-reversal/${year}/${formatMonthToNumber(month)}`,
      search: `${searchParams.toString()}&is_year_end=${month === "Year End December" ? 1 : 0}`,
    });
  };

  const onNavigateBack = () => {
    const newParams = removeQueryParams(["is_year_end", "suppliers", "companies"]);

    const newSearch = new URLSearchParams(newParams).toString();
    navigate({
      pathname: `/general-journal/accrual-and-reversal/`,
      search: newSearch,
    });
  };

  return (
    <Box width={1}>
      <Stack>
        <Divider sx={{ marginTop: 2 }} />
        <Stack direction="row" gap={1} padding={2} height="6vh" alignItems="center">
          <Tooltip title="Back">
            <IconButton onClick={onNavigateBack} color="inherit">
              <ArrowBack />
            </IconButton>
          </Tooltip>
          <Stack direction="row" gap={1}>
            <FolderZipOutlined sx={{ opacity: 0.9 }} />
            <Typography fontWeight={500} fontSize={13} sx={{ opacity: 0.9 }}>
              General Journal Year: <GJChip title={year} />
            </Typography>
          </Stack>
        </Stack>
        <Divider />
      </Stack>

      <Stack width={1} direction="row" gap={2} padding={2} flexWrap="wrap">
        {!isFetching &&
          isSuccess &&
          year !== "all" &&
          Object?.keys(data).map((value) => {
            return (
              <React.Fragment key={value}>
                <CardFolder
                  value={value === "Year End December" ? "13th Month" : value}
                  onClick={() => {
                    navigateToMonthFolder(value);
                  }}
                />
              </React.Fragment>
            );
          })}

        {year === "all" && <DocumentAccrualReversalAllBatch data={data} isFetching={isFetching} />}
        {isFetching && year !== "all" && isSuccess && <FolderLoader />}
      </Stack>

      {((isSuccess && !Object?.values(data)?.length) || isError) && (
        <Stack height={1} direction="row" justifyContent="center" alignItems="center">
          <NoRecordsFound />
        </Stack>
      )}
    </Box>
  );
};

export default Year;
